import { render, staticRenderFns } from "./ManualSubmissionPage.vue?vue&type=template&id=101e68b4"
import script from "./ManualSubmissionPage.vue?vue&type=script&lang=js"
export * from "./ManualSubmissionPage.vue?vue&type=script&lang=js"
import style0 from "./ManualSubmissionPage.vue?vue&type=style&index=0&id=101e68b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports